import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Green_Btn from "../../../common_components/common_btn/green_btn/Green_Btn";
import Success_Modal from "../../../common_components/common_modal/success_modal/Success_Modal";
import Gray_Btn from "../../../common_components/common_btn/gray_btn/Gray_Btn";
import { useDispatch } from "react-redux";
import {
  getAllWalletHistory,
  postAddWithDraw,
} from "../../../../features/wallet/walletSlice";

const Add_withdrawal_request = () => {
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm();

  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    const res = await dispatch(postAddWithDraw({ data }));

    if (res.meta?.requestStatus === "fulfilled") {
      dispatch(getAllWalletHistory());
      setShowSucsessModal(true);
      reset();
    } else if (res.meta?.requestStatus === "rejected") {
      setError("amount", {
        type: "manual",
        message: res.payload?.errors,
      });
    }
  };
  

  return (
    <section className="Add_Money">
      <div className="gray_holder">
        <div className="form">
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* UPI ID */}
            <Form.Group className="input_group">
              <Form.Label>Enter Upi Id</Form.Label>
              <Form.Control
                {...register("upi_id", {
                  required: "UPI ID is required",
                  pattern: {
                    value: /^[\w.-]+@[\w.-]+$/, // simple UPI format validation
                    message: "Enter a valid UPI ID",
                  },
                })}
                placeholder="Enter UPI ID"
                type="text"
                isInvalid={!!errors.upi_id}
              />
              {errors.upi_id && (
                <Form.Control.Feedback type="invalid">
                  {errors.upi_id.message}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            {/* Amount */}
            <Form.Group className="input_group">
              <Form.Label>Enter Amount</Form.Label>
              <Form.Control
                {...register("amount", {
                  required: "Amount is required",
                  min: {
                    value: 1,
                    message: "Amount must be at least 1",
                  },
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Only numbers are allowed",
                  },
                })}
                placeholder="Enter Amount"
                type="text"
                isInvalid={!!errors.amount}
              />
              {errors.amount && (
                <Form.Control.Feedback type="invalid">
                  {errors.amount.message}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <div className="btn_holder d-flex gap-3 mt-3">
              <Gray_Btn btn_name="Cancel" onClick={() => reset()} />
              <Green_Btn btn_name="Save" type="submit" />
            </div>
          </Form>
        </div>
      </div>

      {/* Success Modal */}
      <Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSucsessModal(false)}
        successText="Request Accepted successfully!"
      />
    </section>
  );
};

export default Add_withdrawal_request;
